import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "example-component border p-3" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h2", null, [
  /*#__PURE__*/_createTextVNode("This is an "),
  /*#__PURE__*/_createElementVNode("strong", null, "example Vue component"),
  /*#__PURE__*/_createTextVNode(".")
], -1 /* HOISTED */)
const _hoisted_3 = { class: "mb-3" }
const _hoisted_4 = { class: "mb-3" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", null, "My slot \"content\" is:", -1 /* HOISTED */)
const _hoisted_6 = { class: "mb-3" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", null, "Clicking this button increments the data value \"count\"", -1 /* HOISTED */)

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("p", null, "My prop \"message\" value is: " + _toDisplayString($props.message), 1 /* TEXT */)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _hoisted_5,
      _renderSlot(_ctx.$slots, "content", {}, () => [
        _createTextVNode(" Default content slot value ")
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _hoisted_7,
      _createElementVNode("button", {
        class: "btn btn-red",
        onClick: _cache[0] || (_cache[0] = (...args) => ($options.incrementCount && $options.incrementCount(...args)))
      }, "Click me"),
      _createElementVNode("p", null, "Button click count: " + _toDisplayString($data.count), 1 /* TEXT */)
    ])
  ]))
}